import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PositiveScreeningRateChart from "./PositiveScreeningRateChart";

// Static data for positive screening rate per 1000 units
const STATIC_SCREENING_DATA = {
  tests: ["HIV", "HBsAg", "HCV", "Syphilis", "Malaria"],
  rates: [0.45, 1.20, 0.85, 0.65, 0.30],
};

const PositiveScreeningRateWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={6} lg={6}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Positive Screening Rate per 1000 Units")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <PositiveScreeningRateChart data={STATIC_SCREENING_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default PositiveScreeningRateWrapper;
